<template>
    <GlobalWindow
        :title="title"
        width="500px"
        :visible.sync="visible"
        :confirm-working="isWorking"
        @confirm="confirm"
    >
        <el-form :model="form" ref="form" :rules="rules">
            <el-form-item label="车牌号" prop="code">
                <el-input v-model="form.code" placeholder="请输入车牌号" v-trim/>
            </el-form-item>
            <el-form-item label="用户类型" prop="code">
                <el-radio-group v-model="form.code">
                    <el-radio label="内部员工"></el-radio>
                    <el-radio label="劳务人员"></el-radio>
                </el-radio-group>
            </el-form-item>
            <el-form-item label="选择用户" prop="code">
                <el-select v-model="form.code" filterable placeholder="请选择">
                    <el-option
                        v-for="item in options"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="授权有效期" prop="code">
                <el-date-picker
                    v-model="form.code"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
                </el-date-picker>
            </el-form-item>
            <el-form-item label="授权停车场" prop="code">
                <el-radio-group v-model="form.code">
                    <el-radio label="全部停车场"></el-radio>
                    <el-radio label="部分停车场"></el-radio>
                </el-radio-group>
            </el-form-item>
        </el-form>
    </GlobalWindow>
</template>

<script>
import BaseOpera from '@/components/base/BaseOpera'
import GlobalWindow from '@/components/common/GlobalWindow'
export default {
  name: 'OperaCarsWindow',
  extends: BaseOpera,
  components: { GlobalWindow },
  data () {
    return {
      // 表单数据
      form: {
        id: null,
        code: ''
      },
      // 验证规则
      rules: {
      },
      options: []
    }
  },
  created () {
    this.config({
      api: '/business/cars',
      'field.id': 'id'
    })
  }
}
</script>
